
import Layout from "@/components/Layout";
import AboutContent from "@/components/about/AboutContent";

const AboutPage = () => {
  return (
    <Layout>
      <AboutContent />
    </Layout>
  );
};

export default AboutPage;
